<template>
  <div>
    <div>
      <!--左侧上方搜索框-->
      <div class="searchbox chargeSearchbox">
        <form action="#" method="get" class="form-inline form-float">
          <div class="form-group">
            <label for>道路:</label>
            <search-parking></search-parking>
          </div>
          <div class="form-group">
            <label for>工号:</label>
            <input
              v-model="search.jobNumber"
              class="form-control"
              type="text"
              placeholder
              size="12"
              v-noBlankSpace
            />
          </div>
          <div class="form-group">
            <label for>姓名:</label>
            <input
              v-model="search.name"
              class="form-control"
              type="text"
              placeholder
              size="12"
              v-noBlankSpace
            />
          </div>
          <div class="form-group" for>时间:</div>
          <div class="form-group">
            <el-date-picker
              v-model="search.beginTime"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              placeholder="开始时间"
            ></el-date-picker>
          </div>
          <div class="form-group" for>至</div>
          <div class="form-group">
            <el-date-picker
              value-format="yyyy-MM-dd HH:mm:ss"
              v-model="search.endTime"
              type="datetime"
              placeholder="结束时间"
            ></el-date-picker>
          </div>
          <div class="form-group others">
            <span class="search_btn">
              <button
                @click="searchList"
                type="button"
                class="btn btn-primary"
                id="search_btn"
              >
                查询
              </button>
            </span>
            <span class="add_btn">
              <button
                type="button"
                class="btn btn-default"
                id="addarea"
                @click="addOrEdit()"
              >
                添加
              </button>
            </span>
          </div>
        </form>
      </div>
      <div class="list-right">
        <el-table
          ref="table"
          border
          :data="tableListData"
          height="100%"
          :header-cell-style="tableHeaderStyle"
          :cell-style="styleObj"
        >
          <el-table-column
            show-overflow-tooltip
            label="道路名称"
            prop="parkingName"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="工号"
            prop="jobNumber"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="姓名"
            prop="name"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="用户名"
            prop="username"
          ></el-table-column>
          <el-table-column show-overflow-tooltip label="岗位">
            <template slot-scope="scope">
              <el-dropdown trigger="click">
                <span class="el-dropdown-link">
                  {{
                    scope.row.parkingAreaList
                      ? scope.row.parkingAreaList[0].areaName
                      : ""
                  }}
                  <i
                    v-if="
                      scope.row.parkingAreaList
                        ? scope.row.parkingAreaList.length > 1
                        : 0
                    "
                    class="el-icon-arrow-down el-icon--right"
                  ></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="it in scope.row.parkingAreaList
                      ? scope.row.parkingAreaList.slice(1)
                      : []"
                    v-bind:key="it.areaId"
                    class="areaGroup"
                    >{{ it.areaName }}</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="入职时间"
            prop="entryTime"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="离职时间"
            prop="departureTime"
          ></el-table-column>
          <!-- <el-table-column show-overflow-tooltip label="收费总额" prop="tollSum"></el-table-column> -->
          <el-table-column
            show-overflow-tooltip
            label="创建时间"
            prop="crtTime"
          ></el-table-column>
          <el-table-column show-overflow-tooltip label="操作" width="200px">
            <template slot-scope="scope">
              <button
                type="button"
                class="edit"
                @click="
                  addOrEdit(
                    scope.row.id,
                    scope.row.parkingId
                      ? JSON.parse(scope.row.parkingId).parkingId
                      : ''
                  )
                "
              >
                修改
              </button>
              <button class="delete" @click="del(scope.row.id)">删除</button>
              <button
                type="button"
                class="reset"
                @click="resetPassword(scope.row.id, scope.row.username)"
                style="width: 79px"
              >
                重置密码
              </button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- <Page :pageSize="search.pageSize"></Page> -->
    <Page v-on:pagination="receivePaginationData"></Page>

    <!-- 添加/编辑人员-->
    <el-dialog
      title="添加/编辑人员"
      :close-on-click-modal="false"
      :lock-scroll="false"
      :visible.sync="dialogFormVisibleArea"
      width="500px"
      @open="openDialog"
      @close="closeDialog"
    >
      <el-form
        ref="formArea"
        label-position="right"
        :model="formChargeUser"
        :rules="rulesArea"
        :label-width="formLabelWidth"
      >
        <div class="tip">基本信息</div>
        <hr />

        <el-form-item label="工号" prop="jobNumber">
          <el-col :span="18">
            <el-input v-model.trim="formChargeUser.jobNumber"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="姓名" prop="name">
          <el-col :span="18">
            <el-input v-model.trim="formChargeUser.name"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="用户名" prop="username">
          <el-col :span="18">
            <el-input v-model.trim="formChargeUser.username"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item
          v-if="formChargeUser.id == ''"
          label="密码"
          prop="password"
        >
          <el-col :span="18">
            <el-input
              clearable
              v-model="formChargeUser.password"
              type="password"
            ></el-input>
            <span class="promptText">默认密码0123456</span>
          </el-col>
        </el-form-item>
        <!-- <el-form-item label="性别" prop="sex">
		    		<el-col :span="18">
		      			<el-radio v-model="formChargeUser.sex" label="男">男</el-radio>
  						<el-radio v-model="formChargeUser.sex" label="女">女</el-radio>
		      		</el-col>
        </el-form-item>-->
        <el-form-item label="入职时间" prop="entry">
          <el-col :span="18">
            <el-date-picker
              v-model="formChargeUser.entryTime"
              value-format="yyyy-MM-dd hh:mm:ss"
              align="right"
              type="date"
              placeholder="选择日期"
              :picker-options="pickerOptions1"
            ></el-date-picker>
          </el-col>
        </el-form-item>
        <el-form-item label="离职时间" prop="departureTime">
          <el-col :span="18">
            <el-date-picker
              v-model="formChargeUser.departureTime"
              value-format="yyyy-MM-dd hh:mm:ss"
              align="right"
              type="date"
              placeholder="选择日期"
              :picker-options="pickerOptions1"
            ></el-date-picker>
          </el-col>
        </el-form-item>
        <div class="tip">岗位分配</div>
        <hr />
        <el-form-item label="停车道路" prop="parkingId">
          <el-col :span="18">
            <el-select
              v-model.trim="formChargeUser.parkingId"
              clearable
              @change="onParkingChanged"
            >
              <el-option
                v-for="item in parkingList"
                :label="item.parkingName"
                :value="item.parkingId"
                :key="item.parkingId"
              ></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="岗位" prop>
          <el-col :span="18">
            <el-checkbox-group v-model="checkAreaList">
              <el-checkbox
                v-for="item in areaList"
                :label="item.areaId"
                :key="item.areaId"
                >{{ item.areaName }}</el-checkbox
              >
            </el-checkbox-group>
          </el-col>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addEditTrue">确 定</el-button>
        <el-button @click="dialogFormVisibleArea = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters, mapState, mapMutations } from "vuex";
import {
  addOrEditChargeUser,
  resetChargeUserPassword,
  removeChargeUser,
  oneChargeUser,
  getAllDatas,
  chargeUserList,
  getAllAreas,
  getAllParkingsByEnabled,
  getAreaSingle,
  addEditArea,
  getArea,
  dictValue,
  getOrderList,
  getDirectiveList,
  fetchParkigList,
  fetchAreaList,
} from "@/api/url";

import AreaTree from "../../commons/areaTree";

import Page from "../../commons/page";

import SearchParking from "@/page/commons/searchParking";

export default {
  data() {
    return {
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },
      parkingList: [],
      areaList: [],
      moduleName: "",
      checkAreaList: [],
      allAreaList: [],
      chargeManager_btn_remove: false,
      chargeManager_btn_add: false,
      chargeManager_btn_restpassword: false,
      chargeManager_btn_edit: false,
      dialogFormVisibleArea: false,
      selectedPark: false,
      parkList: false,
      parkingName: "",
      tableListParkDataAll: {},
      tableListDataAll: [],
      unbindArea: {},
      downloadFileds: {
        工号: {
          field: "jobNumber",
          callback: (value) => {
            return value + "";
          },
        },
        姓名: {
          field: "name",
          callback: (value) => {
            return value + "";
          },
        },
        用户名: {
          field: "username",
          callback: (value) => {
            return value + "";
          },
        },
        岗位: {
          field: "parkingAreaList",
          callback: (value) => {
            var list = [];
            if (value) {
              for (let item of value) {
                list.push(item.areaName);
              }
            }
            return list;
          },
        },
        // '性别':'sex',
        入职时间: "entryTime",
        离职时间: "departureTime",
        // '停车道路':{
        // 	field:'parkingId',
        // 	callback:value=>{
        // 		return value!=''&&value!=undefined?JSON.parse(value).parkingName:'';
        // 	}},
        // '泊位段':{
        // 	field:'areaId',
        // 	callback:value=>{
        // 		return value!=''&&value!=undefined?JSON.parse(value).areaName:'';
        // 	}},
        收费总额: "tollSum",
      },
      pickerOptions1: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      moduleName: "",
      formChargeUser: {
        parkingId: null,
        parkingName: null,
        areaId: [],
        areaName: [],
        username: null,
        password: "0123456",
        jobNumber: null,
        entryTime: null,
        departureTime: null,
        id: null,
        name: null,
        sex: null,
      },
      formChargeUserAreaId: [],
      formChargeUserAreaName: [],
      formChargeUserArea: [],
      formLabelWidth: "100px",
      rulesArea: {
        name: [{ required: true, message: "请填写姓名", trigger: "blur" }],
        jobNumber: [{ required: true, message: "请填写工号", trigger: "blur" }],
        username: [
          { required: true, message: "请填写用户名", trigger: "blur" },
        ],
        password: [{ required: true, message: "请填写密码", trigger: "blur" }],
        parkingId: [
          {
            required: true,
            message: "请选择停车道路",
            trigger: ["blur", "change"],
          },
        ],
        // sex: [
        //     { required: true, message: '请填写性别', trigger: 'blur' },
      },
      //allOrderType:[],
      search: {
        pageNumber: 1,
        pageSize: 10,
        name: "",
        jobNumber: "",
        beginTime: "",
        endTime: "",
      },
      tableListData: [],
    };
  },
  methods: {
    ...mapMutations(["getPage"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      this.tableList(this.search.pageNumber);
    },

    handleError(rr, file, fileList) {},
    handleSuccess(response, file, fileList) {
      this.formArea.bgImgUrl = response.data;
    },
    addOrEdit: async function (id, parkingId) {
      var _this = this;
      this.checkAreaList = [];
      this.dialogFormVisibleArea = true;
      await this.getAllParkingLot();
      //添加
      if (id == "" || id == undefined) {
        this.formChargeUser = {
          parkingId: null,
          parkingName: null,
          areaName: null,
          id: null,
          name: null,
          username: null,
          password: "0123456",
          jobNumber: null,
          entryTime: null,
          departureTime: null,
          sex: null,
        };
        this.areaList = [];
      }
      //修改
      else {
        this.$get(oneChargeUser() + "?chargeUserId=" + id).then(
          async (data) => {
            const {
              chargeUser: {
                id,
                name,
                username,
                jobNumber,
                entryTime,
                departureTime,
                parkingId,
              },
            } = data;
            const tempParkingId =
              parkingId && typeof JSON.parse(parkingId) === "object"
                ? JSON.parse(parkingId).parkingId
                : null;
            if (tempParkingId) {
              await this.getAreaList(tempParkingId);
            }
            this.formChargeUser = {
              id,
              name,
              username,
              jobNumber,
              entryTime,
              departureTime,
              parkingId: tempParkingId,
            };
            for (let i of data?.parkingAreas ?? []) {
              this.checkAreaList.push(i.areaId);
            }
          }
        );
      }
    },
    isJsonObj(s) {
      try {
        if (typeof JSON.parse(s) === "object") {
          return true;
        }
      } catch (err) {}
      return false;
    },
    addEditTrue: function () {
      var _this = this;

      this.$refs.formArea.validate(function (valid, noStri) {
        if (valid) {
          _this.dialogFormVisibleArea = false;
          if (!Boolean(_this.formChargeUser.id)) {
            _this
              .$postRequest(addOrEditChargeUser(), {
                parkingId: _this.formChargeUser.parkingId,
                areaId: JSON.stringify(_this.checkAreaList),
                name: _this.formChargeUser.name,
                username: _this.formChargeUser.username,
                password: _this.formChargeUser.password,
                jobNumber: _this.formChargeUser.jobNumber,
                entryTime: _this.formChargeUser.entryTime,
                departureTime: _this.formChargeUser.departureTime,
                sex: _this.formChargeUser.sex,
              })
              .then((data) => {
                if (data.status != 200) return _this.$layer.msg(data.message);
                _this.$notify({
                  type: "success",
                  title: "成功",
                  message: "添加成功",
                });
                _this.search.pageNumber = 1;
                _this.tableList(_this.search.pageNumber);
              });
          } else {
            _this
              .$postRequest(addOrEditChargeUser(), {
                id: _this.formChargeUser.id,
                parkingId: _this.formChargeUser.parkingId,
                areaId: JSON.stringify(_this.checkAreaList),
                name: _this.formChargeUser.name,
                username: _this.formChargeUser.username,
                password: _this.formChargeUser.password,
                jobNumber: _this.formChargeUser.jobNumber,
                entryTime: _this.formChargeUser.entryTime,
                departureTime: _this.formChargeUser.departureTime,
                sex: _this.formChargeUser.sex,
              })
              .then((data) => {
                if (data.status != 200) return _this.$layer.msg(data.message);
                _this.$notify({
                  type: "success",
                  title: "成功",
                  message: "岗位修改成功",
                });

                _this.tableList(_this.curIndex);
              });
          }
        }
      });
    },

    del: function (id) {
      var _this = this;
      var index = _this.$layer.confirm(
        "您确定删除该巡检员信息吗？",
        {
          btn: ["确定", "取消"],
          shade: false,
          type: 0,
        },
        function () {
          _this.$layer.close(index);
          _this
            .$deleteRequest(removeChargeUser() + "?id=" + id, {})
            .then((data) => {
              if (data.status != 200)
                return _this.$layer.msg("删除失败", { time: 1 });
              _this.$notify({
                title: "成功",
                message: "删除成功",
                type: "success",
              });
              _this.tableList(_this.curIndexr);
            });
        }
      );
    },
    tableList: function (curPage) {
      const { beginTime, endTime, name, jobNumber, pageSize } = this.search;
      this.$get(chargeUserList() + "?isDeleted=0", {
        parkingId: this.parking?.parkingId ?? null,
        beginTime: beginTime ? beginTime : null,
        endTime: endTime ? endTime : null,
        name: name ? name : null,
        jobNumber: jobNumber ? jobNumber : null,
        limit: pageSize ? pageSize : 10,
        page: curPage,
      }).then((data) => {
        if (data.status != 200) return this.$layer.msg(data.message);
        //翻页
        var pageObj = {
          curIndex: data.data.offset,
          rowsCount: data.data.total,
        };
        this.getPage(pageObj);
        this.tableListData = (data.data?.rows ?? []).map((item) => {
          if (
            item.parkingId &&
            typeof JSON.parse(item.parkingId) === "object"
          ) {
            item.parkingName = JSON.parse(item.parkingId).parkingName;
          }
          return item;
        });

        this.$nextTick(() => {
          this.$refs.table.doLayout();
        });
      });
    },

    openDialog: function () {},
    closeDialog: function () {
      this.formChargeUserAreaName = [];
      this.formChargeUserAreaId = [];
      this.$refs.formArea.resetFields();
    },
    searchList: function () {
      var flTime = this.timeCompare(this.search.beginTime, this.search.endTime);
      // console.log(this.search.endTime)
      if (flTime) {
        return this.$layer.msg("开始时间请勿大于结束时间", { time: 1 });
      } else if (
        !Boolean(this.search.beginTime) &&
        Boolean(this.search.endTime)
      ) {
        return this.$layer.msg("请选择开始时间", { time: 1 });
      } else if (
        Boolean(this.search.beginTime) &&
        !Boolean(this.search.endTime)
      ) {
        return this.$layer.msg("请选择结束时间", { time: 1 });
      }
      this.search.pageNumber = 1;
      this.tableList(this.search.pageNumber);
    },
    timeCompare: function (bDateVal, eDateVal) {
      if (!Boolean(bDateVal) || !Boolean(eDateVal)) {
        return false;
      }
      var bdate = new Date(Date.parse(bDateVal.replace(/-/g, "/")));
      bdate = bdate.getTime();
      var edate = new Date(Date.parse(eDateVal.replace(/-/g, "/")));
      edate = edate.getTime();
      if (bdate - edate > 0) {
        return true;
      } else {
        return false;
      }
    },
    clearSearch: function () {
      this.search.pageNumber = "1";
      this.search.type = "";
      this.search.startTime = "";
      this.search.endTime = "";
      this.search.devOrder = "";
    },
    resetPassword(username, id) {
      this.$postRequest(
        resetChargeUserPassword() + "?id=" + username + "&username=" + id,
        {
          //username
        }
      ).then((data) => {
        if (data.status != 200) return;
        this.$notify({
          title: "成功",
          message: "重置密码成功,默认密码是0123456",
          type: "success",
        });
      });
    },
    //确定被删除元素的索引值
    indexOf(val, arr) {
      // console.log(arr)
      for (var i = 0; i < arr.length; i++) {
        if (arr[i] == val) {
          return i;
        }
      }
      return -1;
    },
    //删除数组中某个元素
    remove(val, arr) {
      var index = this.indexOf(val, arr);
      if (index > -1) {
        arr.splice(index, 1);
      }
    },
    handleCommand(val) {
      if (val === "所有数据") {
      }
    },
    getAllParkingLot() {
      return this.$get(fetchParkigList()).then((data) => {
        if (data.status === 200) {
          this.parkingList = data.data;
        }
      });
    },
    getAreaList(id) {
      if (id) {
        return this.$get(fetchAreaList(), { parkingId: id }).then((res) => {
          const { status, data } = res;
          if (status === 200) {
            this.areaList = data;
          }
        });
      } else {
        return (this.areaList = []);
      }
    },
    onParkingChanged(val) {
      this.checkAreaList = [];
      this.getAreaList(val);
    },
  },
  computed: {
    ...mapState({
      curIndex: (state) => state.page.curIndex,
      rowsCount: (state) => state.page.rowsCount,
      parking: (state) => state.parking.oneParking,
    }),
    ...mapGetters(["elements"]),
    permiss() {
      this.chargeManager_btn_remove = this.elements["chargeManager:btn_remove"];
      this.chargeManager_btn_add = this.elements["chargeManager:btn_add"];
      this.chargeManager_btn_restpassword = this.elements[
        "chargeManager:btn_restpassword"
      ];
      this.chargeManager_btn_edit = this.elements["chargeManager:btn_edit"];
    },
  },
  components: {
    Page,
    AreaTree,
    SearchParking,
    // Refresh,
    // AreaTree
  },
  created: function () {
    this.permiss;
  },
  mounted: function () {
    this.tableList(this.search.pageNumber);
  },
  watch: {
    elements: {
      handler: function (val, oldVal) {
        this.permiss;
      },
      deep: true, //深度
    },
  },
};
</script>

<style scoped>
.modal-body .tab-img li {
  width: 100px;
  height: 100px;
  margin: 10px 10px;
}
.el-input {
  display: inline-block;
  width: 200px;
}
.btns {
  margin: 20px auto 0;
  width: 150px;
}
.searchbox {
  padding-bottom: 10px;
}
/* .left{
		float:left;
		width:20%;
		 */
/*border-right:1px solid #278cd8;*/
/* } */
/* .right{
		float:right;
		width:80%;
	} */
.clearth {
  clear: both;
}

.area {
  width: 100%;

  display: inline-block;
}

.edit,
.delete {
  display: inline-block;
  width: 40px;
  height: 20px;
  background: #278cd8;
  color: white;
  margin-right: 4px;
  font-size: 12px;
  line-height: 20px;
  border-radius: 4px;
}
.list {
  position: relative;
}
.pagbox {
  position: absolute;
  bottom: 5px;
  right: 5px;
}
.el-radio {
  display: inline-block;
  height: 34px;
  line-height: 34px;
}
.el-form-item__error,
.el-input {
  float: left;
}
.tip {
  margin-top: -2%;
  color: red;
  font-size: 14px;
  font-weight: bold;
}
hr {
  margin: 5px 0 10px 0 !important;
  border-top: 1px solid #ddd !important;
}
/* .areaGroup{
		display:inline-block;
		margin-right:5px;
		margin-top:5px;
		padding:0 2px;
		background:#ddd;
		border-radius:2px;
		font-size:12px;
		
	}
	 */
.table > tbody > tr > td {
  border: none;
}
.download_btn .el-dropdown-link {
  display: inline-block;
  cursor: pointer;
  color: white;
  background: #278cd8;
  height: 34px;
  border-radius: 5px;
  padding-left: 5px;
  font-size: 12px;
  line-height: 37px;
  width: 90px;
}
.download_btn .el-icon-arrow-down {
  font-size: 12px;
}
</style>
<style>
.chargeSearchbox .form-control {
  width: 100px !important;
}
.charge .el-dropdown-menu {
  width: 200px !important;
}
</style>